import { render } from "./NotificationSettingsView.vue.js?vue&type=template&id=37cc06d7!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NotificationSettingsView.vue?vue&type=template&id=37cc06d7"
import script from "./NotificationSettingsView.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NotificationSettingsView.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsView.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NotificationSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/FanWeb/scripts/components/notifications/NotificationSettingsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37cc06d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37cc06d7', __exports__)) {
    api.reload('37cc06d7', __exports__)
  }
  
  module.hot.accept("./NotificationSettingsView.vue.js?vue&type=template&id=37cc06d7!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NotificationSettingsView.vue?vue&type=template&id=37cc06d7", () => {
    api.rerender('37cc06d7', render)
  })

}


export default __exports__